import { render } from "./OrganizationLink.vue?vue&type=template&id=fd285646&scoped=true"
import script from "./OrganizationLink.vue?vue&type=script&lang=js"
export * from "./OrganizationLink.vue?vue&type=script&lang=js"

import "./OrganizationLink.vue?vue&type=style&index=0&id=fd285646&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd285646"]])

export default __exports__